export const routesPaths = {
  login: '/auth/login',
  register: '/auth/register',
  reset: '/auth/reset',
  help: '/help',
  setPassword: '/auth/reset-password',
  changePassword: '/change-password',
  mobile: '/auth/mobile',
  inspection: '/project/:projectId/inspection',
  reviewInspection: '/project/:projectId/inspection/:inspectionId/review',
  reviewObservation: '/project/:projectId/observation/:observationId/review',
  reviewIncident: '/project/:projectId/incident/:incidentId/review',
  profile: '/edit-profile',
  plans: '/plans',
  observation: '/project/:projectId/observation',
  incident: '/project/:projectId/incident',
  projects: '/projects',
  createProject: '/project/setup/:step',
  projectSetup: '/project/setup/:setupId/:step',
  checklist: '/checklist',
  checklistSetup: '/checklist/:libId/:checklistId',
  users: '/users',
  projectDashboard: '/project/:projectId',
  onboarding: 'onboarding',
  onboardingPage: 'onboarding/:page',
  conductInspection: '/project/:projectId/conduct-inspection',
  conductInspectionSetup:
    '/project/:projectId/conduct-inspection/:inspectionId/:step',
  scheduleInspection: '/project/:projectId/schedule-inspection',
  scheduledInspections: '/project/:projectId/scheduled-inspections',
  logObservation: '/project/:projectId/log-observation',
  addObservation: '/project/:projectId/log-observation/:observationId/:step',
  recordIncident: '/project/:projectId/record-incident',
  addIncident: '/project/:projectId/record-incident/:incidentId/:step',
  allTasks: '/projects/tasks',
  projectTasks: '/project/:projectId/tasks',
  inspectionTasks: '/project/:projectId/inspection/tasks',
  observationTasks: '/project/:projectId/observation/tasks',
  incidentTasks: '/project/:projectId/incident/tasks',
  scheduledInspectionTasks: '/project/:projectId/schedule_inspection/tasks',
  editSubProjects: '/project/:setupId/edit-sub-projects',
  editChecklist: '/project/:setupId/edit-checklist',
  editDocuments: '/project/:setupId/edit-documents',
  editTeams: '/project/:setupId/edit-teams',
  dashboard: '/dashboard',
  appDemo: '/app-demo',
};

export const navLinks = {
  login: '/auth/login',
  register: '/auth/register',
  forgotPassowrd: '/auth/reset',
  mobile: '/auth/mobile',
  inspection: '/project/:projectId/inspection',
  observation: '/project/:projectId/observation',
  incident: '/project/:projectId/incident',
  projects: '/projects',
  projectSetup: '/project/setup/1',
  checklist: '/checklist',
  checklistSetup: '/checklist/setup',
  users: '/users',
};

export const apiUrl = {
  login: '/auth/login-user',
  register: '/auth/register-user',
  google: '/auth/google',
  reset: '/auth/reset-password-mail',
  setPassowrd: '/auth/set-password',
  mobile: '/auth/mobile',
  getUserDetails: '/users/@me',
  project: '/users/projects',
  users: '/users/team',
  checklistLibrary: '/users/checklists-library',
  checklists: '/users/checklists',
  sendInvite: '/users/send-invite',
  sendOtp: 'users/onboarding/send-otp',
  verifyOtp: 'users/onboarding/verify-otp',
  uploadAsset: 'users/assets',
};
